import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Incarico } from '../../models/incarico';
import { baseUrl } from '../api-config';


@Injectable({
  providedIn: 'root'
})
export class LavoriInCorsoService {

  constructor(private http: HttpClient) { }


  getLavoriInCorso(inAttesaDiSopralluogo = false, groupByComune = false): Promise<any> {
    return this.http.get<any>(`${baseUrl}/statistiche/lavori-in-corso?inAttesaDiSopralluogo=${inAttesaDiSopralluogo}&groupByComune=${groupByComune}`)
      .pipe(
        map(response => {
          if (groupByComune) {
            // Return grouped data with deserialized incarichi
            return response.map(group => ({
              ...group,
              incarichi: group.incarichi.map(model => new Incarico().deserialize(model))
            }));
          } else {
            // Return flat array of deserialized incarichi
            return response.map(model => new Incarico().deserialize(model));
          }
        })
      )
      .toPromise();
  }

}
